import {Button} from '@wandb/weave/components';
import {Icon} from '@wandb/weave/components/Icon';
import classNames from 'classnames';
import React from 'react';

import {useIssuesContext} from '../../../state/issues/IssuesContext';
import {Issue as IssueType} from '../../../state/issues/types';

export const RunIssuesList = ({
  hoveredIssue,
  issues,
}: {
  hoveredIssue: string | null;

  issues: IssueType[];
}) => {
  const {workspaceType} = useIssuesContext();
  return (
    <section data-test="run-issues-list">
      <ul>
        {issues
          .sort((a, b) => b.timestamp - a.timestamp)
          .map(issue => (
            <Issue
              isActive={
                hoveredIssue === issue?.id && workspaceType === 'single-run'
              }
              key={issue?.id}
              {...issue}
            />
          ))}
      </ul>
    </section>
  );
};
export const Issue = ({
  description,
  id,
  isActive,
  grafanaDashboard,
  timestamp,
  title,
}: IssueType & {
  isActive: boolean;
}) => {
  const classes = classNames({
    'border-teal-600': isActive,
    'border-moon-250': !isActive,
  });
  const {handleIssueInteraction} = useIssuesContext();
  return (
    <li
      className={`mt-16 rounded-lg border-[2px] px-16 py-20 ${classes}`}
      data-test="run-issue-list-item"
      id={id}
      onMouseEnter={handleIssueInteraction('hover', id)}
      onMouseLeave={handleIssueInteraction('unhover', null)}>
      <article data-test="run-issue-card">
        <div className="text-lg font-semibold">{title}</div>
        <div className="my-8 flex items-center justify-start gap-10">
          <div className="text-moon-650">
            {new Date(timestamp).toLocaleString()}
          </div>
          <div className="h-4 w-4 rounded-full bg-moon-650" />
          <Button
            variant="ghost"
            onClick={() => {
              // eslint-disable-next-line
              window.open(grafanaDashboard, '_blank', 'noopener noreferrer');
            }}>
            <span className="flex items-center gap-4">
              <Icon name="grafana" />
              Grafana
            </span>
          </Button>
        </div>
        <p className="text-sm">{description}</p>
      </article>
    </li>
  );
};
